import { useEffect, useState, useCallback } from "react";
import { useUI } from "@/context/UIContext";
import { visibleInterval } from "@/lib/poll";

// Loads block data; refetches when deps change, on global data bumps, and optionally on an interval.
export function useBlockData(fetcher, deps, pollMs) {
  const { dataVersion } = useUI();
  const [data, setData] = useState(null);
  const load = useCallback(() => fetcher().then(setData).catch(() => setData((d) => d || [])), deps); // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(() => { load(); }, [load, dataVersion]);
  useEffect(() => {
    if (!pollMs) return undefined;
    return visibleInterval(load, pollMs);
  }, [load, pollMs]);
  return [data, load, setData];
}

export function BlockEmpty({ children }) {
  return <p className="py-6 text-center text-xs text-slate-300">{children}</p>;
}
